import type { RouteRecordRaw } from 'vue-router';
import FullLayout from '@/layouts/full/FullLayout.vue';

// Módulo Inovação — rota de permissão única (/inovacao); as telas herdam o
// nível dela em utils/userRouteAccess.ts (regex fechada). A fila "Ideias" é
// adicionalmente gateada por diretoria de CC no backend (403).
export const inovacaoRoutes: RouteRecordRaw[] = [
  {
    path: '/inovacao',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Inovação - Hub AtlanGlobal', forceFullWidth: true },
    children: [
      { path: '', redirect: '/inovacao/minhas' },
      { path: 'nova', name: 'InovacaoNovaIdeia', component: () => import('@/views/Inovacao/NovaIdeia.vue'), meta: { title: 'Nova ideia', breadcrumb: 'Nova ideia' } },
      { path: ':id(\\d+)/editar', name: 'InovacaoEditarIdeia', component: () => import('@/views/Inovacao/NovaIdeia.vue'), props: true, meta: { title: 'Editar rascunho', breadcrumb: 'Editar' } },
      { path: 'minhas', name: 'InovacaoMinhasIdeias', component: () => import('@/views/Inovacao/MinhasIdeias.vue'), meta: { title: 'Minhas ideias', breadcrumb: 'Minhas ideias' } },
      { path: 'ideias', name: 'InovacaoIdeias', component: () => import('@/views/Inovacao/IdeiasAvaliacao.vue'), meta: { title: 'Ideias', breadcrumb: 'Ideias' } },
      { path: ':id(\\d+)', name: 'InovacaoIdeiaDetalhe', component: () => import('@/views/Inovacao/IdeiaDetalhe.vue'), props: true, meta: { title: 'Detalhe da ideia', breadcrumb: 'Ideia' } },
    ],
  },
];

export default inovacaoRoutes;
